import React, { useRef, useState, useEffect } from 'react';
import pluralize from 'pluralize';
import InfiniteScroll from 'react-infinite-scroll-component';
// Local
import { Loading } from '../shared-components';
import ResourceMapHeader from './ResourceMapHeader';
import ResourceListItem from './ResourceListItem';
export default function ResourceMapUI(_a) {
    var globalConfig = _a.globalConfig, globalState = _a.globalState, listConfig = _a.listConfig, updateFilter = _a.updateFilter, currentList = _a.currentList, selectedResources = _a.selectedResources, dataByUid = _a.dataByUid, onResetMap = _a.onResetMap, onResetFilters = _a.onResetFilters, onUpdateModalResource = _a.onUpdateModalResource, onSelectResource = _a.onSelectResource, nextPage = _a.nextPage;
    var searchRef = useRef(null);
    var _b = useState(false), searchFocused = _b[0], setSearchFocused = _b[1];
    var _c = useState(false), isFiltered = _c[0], setIsFiltered = _c[1];
    useEffect(function () {
        var _a;
        setIsFiltered(JSON.stringify(globalState.currentFilter) !== JSON.stringify(globalConfig.defaultFilter));
        var searchTerm = ((_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.value) || '';
        if (globalState.currentFilter.query !== searchTerm)
            clearSearchInput();
    }, [globalState.currentFilter]);
    var filterString = function () {
        var _a = globalState.currentFilter, agency = _a.agency, category = _a.category, county = _a.county, city = _a.city, fundingStream = _a.fundingStream, recipient = _a.recipient, year = _a.year, featured = _a.featured, query = _a.query;
        var isCitySelected = Boolean(city && city !== 'all');
        var isCountySelected = Boolean(county && county !== 'all');
        if (!listConfig.showFilterString)
            return '';
        if (listConfig.defaultFilterString && (!county || county == 'all'))
            return listConfig.defaultFilterString;
        var resourceLabel = "".concat(featured ? 'featured ' : '').concat(globalConfig.resourceLabel);
        var filterString = "No ".concat(pluralize(resourceLabel, 0, false), " published");
        if (globalState.totalRows)
            filterString = "Showing <span>".concat(pluralize(resourceLabel, globalState.totalRows, true), "</span>");
        var categoryString = '';
        var categoryPrefix = 'tagged ';
        if (category) {
            categoryString = " ".concat(categoryPrefix, " <span>\"").concat(category, "\"</span>");
        }
        if (categoryString.length)
            filterString += categoryString;
        var where = '';
        if (county == 'statewide') {
            if (listConfig.mapLocationName)
                where = " across ".concat(listConfig.mapLocationName, "</span>");
        }
        else if (county == 'all') {
            if (listConfig.mapLocationName)
                where = " for counties within ".concat(listConfig.mapLocationName, "</span>");
        }
        else if (isCountySelected) {
            where = " ".concat(listConfig.countyFilterPreposition, " <span>").concat(county, " ").concat(pluralize(globalConfig.countySuffixLabel, 1), "</span>");
        }
        else if (isCitySelected) {
            where = " in <span>".concat(city).concat((city && city == 'all') ? 'cities' : '', "</span>");
        }
        else {
            var allString = '';
            if (listConfig.mapLocationName) {
                allString = listConfig.mapLocationName;
            }
            else if (globalState.totalRows) {
                allString = "all ".concat(pluralize(globalConfig.countySuffixLabel.toLowerCase(), 0));
            }
            else {
                allString = "any ".concat(pluralize(globalConfig.countySuffixLabel.toLowerCase(), 0));
            }
            where = " ".concat(listConfig.countyFilterPreposition, " <span>").concat(allString, "</span>");
        }
        if (where.length)
            filterString += where;
        var agencyString = '';
        var agencyPrefix = listConfig.agencyPrefix || 'from the ';
        if (agency) {
            agencyString = " ".concat(agencyPrefix, "<span>").concat(agency, "</span>");
        }
        if (agencyString.length)
            filterString += agencyString;
        var fundingStreamString = '';
        var fundingStreamPrefix = listConfig.fundingStreamPrefix || 'and funded by ';
        if (fundingStream) {
            fundingStreamString = " ".concat(fundingStreamPrefix, "<span>").concat(fundingStream, "</span>");
        }
        if (fundingStreamString.length)
            filterString += fundingStreamString;
        var yearString = '';
        var yearPrefix = listConfig.yearPrefix || 'during';
        if (year) {
            yearString = " ".concat(yearPrefix, " <span>").concat(year, "</span>");
        }
        if (yearString.length)
            filterString += yearString;
        var queryString = '';
        var queryPrefix = 'matching search term ';
        if (query) {
            queryString = " ".concat(queryPrefix, " <span>\"").concat(query, "\"</span>");
        }
        if (queryString.length)
            filterString += queryString;
        var recipientString = '';
        var recipientPrefix = 'allocated to ';
        if (recipient) {
            recipientString = " ".concat(recipientPrefix, " <span>").concat(recipient, "</span>");
        }
        if (recipientString.length)
            filterString += recipientString;
        return filterString;
    };
    var handleResetMap = function () {
        onResetMap();
    };
    var handleResetFilters = function () {
        onResetFilters();
    };
    var handleFilterChange = function (event) {
        var _a;
        var _b, _c;
        event.preventDefault();
        var _d = event.target, name = _d.name, value = _d.value;
        var column = (_c = (_b = name === null || name === void 0 ? void 0 : name.split('-')) === null || _b === void 0 ? void 0 : _b.slice(1)) === null || _c === void 0 ? void 0 : _c[0];
        if (!column)
            return;
        var newFilter = (_a = {},
            _a[column] = value,
            _a);
        updateFilter(newFilter);
    };
    var handleSubmitSearch = function (event) {
        var _a, _b, _c, _d;
        event.preventDefault();
        var searchTerm = ((_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.value) || '';
        var searchCols = ((_d = (_c = (_b = searchRef.current) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.split('-')) === null || _d === void 0 ? void 0 : _d.slice(1)) || 'project_name';
        updateFilter({
            query: searchTerm,
            queryCol: searchCols,
        });
    };
    var onClearSearch = function (event) {
        event.preventDefault();
        clearSearchInput();
        updateFilter({ query: '' });
    };
    var clearSearchInput = function () {
        var searchInput = searchRef.current;
        if (searchInput)
            searchInput.value = '';
    };
    var onSearchFocus = function () {
        setSearchFocused(true);
    };
    var onSearchBlur = function () {
        setSearchFocused(false);
    };
    return (React.createElement("div", { className: "row no-gutters flex-column flex-xl-row justify-content-end h-100" },
        React.createElement("div", { className: "EventPage__mapUiActiveCol col" },
            React.createElement("div", { className: "EventPage__resetButtonContainer" },
                React.createElement("button", { className: "js-filter-reset Button Button--secondary Button--sm", onClick: handleResetMap }, "Reset Map"))),
        React.createElement("div", { className: "EventPage__mapUiContentCol col-8 col-xl-auto mw-100 h-100" },
            React.createElement("div", { id: "EventPage__infiniteScrollWindow", className: "EventPage__contentBox h-100" },
                React.createElement("div", { className: "EventPage__header" },
                    React.createElement(ResourceMapHeader, { globalConfig: globalConfig })),
                React.createElement("div", { className: "EventPage__listControls" }, listConfig.filters.map(function (row, index) {
                    return (React.createElement("div", { key: "list-control-".concat(index), className: "EventPage__listControlRow row" }, row.map(function (filter) {
                        var _a, _b, _c, _d;
                        var fieldName = "".concat(((_a = filter.columns) === null || _a === void 0 ? void 0 : _a.reduce(function (className, column) { return "".concat(className, "-").concat(column); })) || filter.column || 'project_name');
                        return (React.createElement("div", { className: "EventPage__listControlCol col".concat(filter.width ? '-' + parseInt(filter.width) : ''), key: "list-control-col-".concat(filter.column) }, {
                            'divider': React.createElement(React.Fragment, null,
                                React.createElement("hr", { className: "EventList__divider" })),
                            'select': React.createElement(React.Fragment, null,
                                React.createElement("label", { className: "EventPage__listControlLabel", htmlFor: "select-".concat(fieldName), dangerouslySetInnerHTML: { __html: filter.label } }),
                                React.createElement("select", { className: 'InputSelect', disabled: Boolean(!((_c = (_b = listConfig.distinctColValues) === null || _b === void 0 ? void 0 : _b[filter.column]) === null || _c === void 0 ? void 0 : _c.length)), id: "select-".concat(fieldName), name: "select-".concat(fieldName), onChange: function (event) { return handleFilterChange(event); }, value: globalState.currentFilter[filter.column] },
                                    React.createElement(SelectFilterGrouping, { defaults: filter.default, options: (_d = listConfig.distinctColValues) === null || _d === void 0 ? void 0 : _d[filter.column] }))),
                            'search': React.createElement(React.Fragment, null,
                                React.createElement("form", { className: "EventList__searchForm", onSubmit: handleSubmitSearch },
                                    React.createElement("div", { className: "EventList__searchFormLabel" }, Boolean(filter.label) ?
                                        (React.createElement("label", { className: "EventPage__listControlLabel", htmlFor: "search-".concat(fieldName), dangerouslySetInnerHTML: { __html: filter.label } })) : (React.createElement("label", { className: "sr-only", htmlFor: "search-".concat(fieldName) }, "Search items"))),
                                    React.createElement("div", { className: "EventList__searchFormField" },
                                        React.createElement("input", { name: "search-".concat(fieldName), id: "search-".concat(fieldName), ref: searchRef, className: "w-100", type: "text", onFocus: onSearchFocus, onBlur: onSearchBlur, placeholder: "Search" }),
                                        globalState.currentFilter.query &&
                                            React.createElement("button", { type: "button", className: "EventList__searchClearButton".concat(searchFocused ? ' focus' : ''), onClick: onClearSearch },
                                                React.createElement("span", null, "Clear"),
                                                React.createElement("span", { className: "sr-only" }, "search query")),
                                        React.createElement("button", { type: "submit", className: "Button Button--primary" },
                                            React.createElement("span", { className: "sr-only" }, "Submit search query"),
                                            React.createElement("span", { className: "fa fa-search" })))))
                        }[filter.type]));
                    })));
                })),
                React.createElement("div", { className: "EventPage__listContainer pt-3" },
                    React.createElement("div", { className: "EventPage__returnToTop row no-gutters justify-content-end" },
                        React.createElement("div", { className: "col-auto pt-3 px-3" },
                            React.createElement("button", { className: "js-return-to-top Button Button--primary Button--xs" },
                                React.createElement("span", { className: "fa fa-filter" }),
                                "\u00A0Filter"))),
                    React.createElement("div", { className: "EventList__filterString" },
                        React.createElement("span", { dangerouslySetInnerHTML: { __html: filterString() } }),
                        listConfig.showFilterReset && isFiltered &&
                            React.createElement("button", { className: "EventList__filterResetButton", onClick: handleResetFilters },
                                React.createElement("span", { className: "Button__label" }, "Clear Filters"))),
                    React.createElement("div", { id: "react-event-list", className: "EventPage__eventList" },
                        React.createElement(InfiniteScroll, { style: { overflowY: 'hidden' }, dataLength: (currentList === null || currentList === void 0 ? void 0 : currentList.length) || 0, next: nextPage, hasMore: ((currentList === null || currentList === void 0 ? void 0 : currentList.length) < globalState.totalRows), loader: React.createElement(Loading, null), 
                            // scrollThreshold="200px"
                            scrollableTarget: "EventPage__infiniteScrollWindow" }, Boolean(dataByUid && (currentList === null || currentList === void 0 ? void 0 : currentList.length)) && currentList.map(function (uid) {
                            if (!dataByUid[uid]) {
                                console.log(uid);
                                return React.createElement(React.Fragment, null);
                            }
                            var itemData = dataByUid[uid];
                            var isSelected = Boolean(selectedResources === null || selectedResources === void 0 ? void 0 : selectedResources.includes(uid));
                            return (React.createElement(ResourceListItem, { key: uid, data: itemData, globalConfig: globalConfig, openModalItem: onUpdateModalResource, selectItem: onSelectResource, isSelected: isSelected }));
                        }))))))));
}
var SelectFilterGrouping = function (_a) {
    var defaults = _a.defaults, options = _a.options;
    var groups = [[]];
    var groupMeta = {};
    var currentGroup = 0;
    if ((defaults === null || defaults === void 0 ? void 0 : defaults.length) && Array.isArray(defaults[0])) {
        defaults.forEach(function (_a) {
            var label = _a[0], value = _a[1];
            if (value.toLowerCase() == 'group') {
                currentGroup++;
                groupMeta[currentGroup] = { label: label };
                if (!Array.isArray(groups[currentGroup]))
                    groups[currentGroup] = [];
            }
            else {
                if (!Array.isArray(groups[currentGroup]))
                    groups[currentGroup] = [];
                groups[currentGroup].push([label, value]);
            }
        });
    }
    else if (defaults === null || defaults === void 0 ? void 0 : defaults.length) {
        var label = defaults[0], value = defaults[1];
        groups[currentGroup].push([label, value]);
    }
    if (options === null || options === void 0 ? void 0 : options.length)
        options.forEach(function (label) {
            // Rows from DB have same label and value in <option> tags
            groups[currentGroup].push([label, label]);
        });
    return (React.createElement(React.Fragment, null, Boolean(defaults === null || defaults === void 0 ? void 0 : defaults.length) && (groups.map(function (group, index) { return (React.createElement(React.Fragment, null, index ? (React.createElement("optgroup", { key: groupMeta[index].label, label: groupMeta[index].label }, group.map(function (_a) {
        var label = _a[0], value = _a[1];
        return (React.createElement("option", { key: "".concat(value), value: value, dangerouslySetInnerHTML: { __html: label } }));
    }))) : (group.map(function (_a) {
        var label = _a[0], value = _a[1];
        return (React.createElement("option", { key: value, value: value, dangerouslySetInnerHTML: { __html: label } }));
    })))); }))));
};
